<script setup lang="ts">
import { ArrowLeftRight, ArrowRight } from 'lucide-vue-next';

const criteriaStore = useSearchCriteriaStore();
const locationLabels = useLocationLabels();
</script>

<template>
  <span class="text-xs font-normal text-text-inverse md:hidden">{{
    criteriaStore.committedCriteriaKey.legs[0]?.from?.code
  }}</span>
  <span class="hidden text-sm font-normal text-text-inverse md:inline">{{
    locationLabels.city(criteriaStore.committedOriginCode)
  }}</span>
  <span class="flex items-center justify-center text-text-inverse">
    <component
      :is="criteriaStore.committedIsOneWay ? ArrowRight : ArrowLeftRight"
      aria-hidden="true"
      class="h-4 w-4"
    />
  </span>
  <span class="text-xs font-normal text-text-inverse md:hidden">{{
    criteriaStore.committedCriteriaKey.legs[0]?.to?.code
  }}</span>
  <span class="hidden text-sm font-normal text-text-inverse md:inline">{{
    locationLabels.city(criteriaStore.committedDestinationCode)
  }}</span>
</template>
